/**
 * Created by Florin David on 02/12/2016.
 */
import { getState } from 'lib/store'

/**
 * Get local (selected language)
 *
 * @return {String}
 */
export const getLocale = (): string => getState().intl.locale

/**
 * Get local messages (selected language)
 *
 * @return {Object}
 */
export const getMessages = (): Record<string, string> =>
  getState().intl.messages

export const isFetchingTranslations = (): boolean =>
  getState().intl.fetchingMessages

export const getUpdatedAt = (): DateISOString => getState().intl.updatedAt
